export default __webpack_public_path__ + "static/logo-3d3e541739212f554bb0d12688e05e83.png";